import React from 'react';
import styled from '@emotion/styled';

import { Button } from 'client/shared/Button/NewButton';
import { SCREEN_BREAKPOINTS } from '../../../constants';
import { AdsByAnchorIcon } from '../../Icons';

const HeaderContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 575px;
  margin: auto;
  padding: 100px 0 0;

  .ads-by-anchor-icon {
    width: 100%;
    max-width: 500px;
    margin: auto;
    padding-bottom: 25px;
  }

  button {
    margin: 0 auto;
  }

  @media (max-width: ${SCREEN_BREAKPOINTS.SMALL_DESKTOP}px) {
    width: 90%;
    padding: 0;
  }
`;
const HiddenHeaderTitle = styled.h1`
  display: none;
`;
const HeaderSubtitle = styled.p`
  margin: 0 0 30px;
  color: #ffffff;
  font-size: 2.5rem;
  line-height: 3.5rem;
  letter-spacing: -0.01em;
  text-align: center;

  @media (max-width: ${SCREEN_BREAKPOINTS.MOBILE}px) {
    margin: 0 0 25px;
    font-size: 2.2rem;
    line-height: 2.8rem;
  }
`;

export const HeaderContent = () => {
  return (
    <HeaderContentContainer>
      <HiddenHeaderTitle>Ads by Anchor</HiddenHeaderTitle>
      <AdsByAnchorIcon aria-hidden={true} />
      <HeaderSubtitle>
        The all-in-one, flexible podcast monetization platform made for
        everyone, powered by Spotify.
      </HeaderSubtitle>
      <Button color="yellow">Sign Up</Button>
    </HeaderContentContainer>
  );
};
